<!-- Portfel — app shell: sidebar, filters, banners, view, details drawer. -->
<script lang="ts">
  import { onMount } from "svelte";
  import { boot, closeDrawer } from "./lib/actions";
  import { app, routeFromHash } from "./lib/state.svelte";
  import Sidebar from "./shell/Sidebar.svelte";
  import TopBar from "./shell/TopBar.svelte";
  import Banner from "./shell/Banner.svelte";
  import Welcome from "./shell/Welcome.svelte";
  import Drawer from "./shell/Drawer.svelte";
  import { VIEWS } from "./views";

  onMount(() => {
    const onHash = () => (app.route = routeFromHash(location.hash));
    onHash();
    window.addEventListener("hashchange", onHash);
    boot().catch((e: Error) => {
      app.bootError = e.message;
      app.screen = "error";
    });
    return () => window.removeEventListener("hashchange", onHash);
  });
  $effect(() => {
    document.body.classList.toggle("privacy", app.privacy);
    document.body.classList.toggle("welcome", app.screen === "welcome");
  });
  const View = $derived(VIEWS[app.route] ?? VIEWS.dashboard);
</script>

<svelte:window onkeydown={(e) => { if (e.key === "Escape" && app.drawerKey) closeDrawer(); }} />

<Sidebar />
<main>
  <TopBar />
  {#if app.screen === "app"}<Banner />{:else}<div id="banner"></div>{/if}
  <section id="view" aria-live="polite">
    {#if app.screen === "welcome"}
      <Welcome />
    {:else if app.screen === "error"}
      <div class="notice">Nie udało się uruchomić aplikacji: {app.bootError}</div>
    {:else if app.screen === "app" && app.model}
      <svelte:boundary>
        <View />
        {#snippet failed(error)}
          <div class="notice">Błąd widoku: {(error as Error).message}</div>
        {/snippet}
      </svelte:boundary>
    {:else}
      <div class="loading">{app.loadingMsg}</div>
    {/if}
  </section>
</main>
<Drawer />
{#if app.toast}<div id="toast" class="toast">{app.toast}</div>{/if}
